import { render, staticRenderFns } from "./RoleView.vue?vue&type=template&id=a4c285be&"
import script from "./RoleView.js?vue&type=script&lang=js&"
export * from "./RoleView.js?vue&type=script&lang=js&"
import style0 from "./RoleView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports